import cn from 'classnames';
import { useParams } from 'react-router-dom';
import Layout from '@components/layout';
import TableHeading from '@modules/blackjack/ingame-table-heading';
import Table from '@modules/blackjack/ingame-table';
import MoreGames from '@modules/blackjack/ingame-more-games';
import useBlackjackLobby from './useBlackjackLobby';
import styles from './blackjack.module.scss';

const Ingame = (): JSX.Element => {
  const { gameUid } = useParams();

  useBlackjackLobby(gameUid);

  return (
    <Layout className={styles.ingameLayout} title="blackjack">
      <div className={styles.game}>
        <TableHeading className="section-spacing" />
        <Table className={styles.game__table} />
      </div>
      <MoreGames className={cn(styles.moreGames, 'section-spacing')} />
    </Layout>
  );
};

export default Ingame;
